import { Avatar, Box, Button, Group, Menu, Stack, Text } from "@mantine/core";
import {
  IconChevronDown,
  IconFileDollar,
  IconLogout,
  IconSettings,
  IconUser,
} from "@tabler/icons-react";
import { useProfileStore, useSessionStore } from "../../stores/UserStore";
import { useMemo, useState } from "react";
import { useLanguage } from "../../stores/LanguageStore";
import { Link, useNavigate } from "react-router-dom";
import { modals } from "@mantine/modals";
import HeaderTools from "./HeaderTools";
import HeaderStats from "./HeaderStats";
import { getPermission } from "../../functions/utilFunctions";

const iconSize = 21;

const HeaderProfile = () => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  const profile = useProfileStore((s) => s.profile);

  const [opened, setOpened] = useState(false);

  const links = useMemo(() => {
    let result = [
      {
        icon: <IconUser size={iconSize} />,
        name: lang.header.menus.link_groups.profile,
        url: "/settings/profile",
      },
      {
        icon: <IconSettings size={iconSize} />,
        name: lang.new_header.settings,
        url: "/settings",
      },
    ];

    if (getPermission("displayPricing")) {
      result.push({
        icon: <IconFileDollar size={iconSize} />,
        name: lang.new_header.billing,
        url:
          reseller?.name === "Magileads"
            ? "/settings/subscription"
            : reseller?.pricing_url,
      });
    }
    return [result];
  }, [
    lang.header.menus.link_groups.profile,
    lang.new_header.billing,
    lang.new_header.settings,
    reseller?.name,
    reseller?.pricing_url,
  ]);

  const navigate = useNavigate();
  const handleLogout = () => {
    function main() {
      let s = useSessionStore.getState();
      s.setUserSwitch(null);
      s.setSession(null);
      let api_url = localStorage.getItem("api_url");

      localStorage.clear();

      window.$chatwoot?.reset();

      setTimeout(() => {
        let p = useProfileStore.getState();
        p.setProfile(null);
        navigate("/login?logged_out=true");

        localStorage.setItem("api_url", api_url);
      }, 50);
    }

    modals.openConfirmModal({
      title: lang.new_header.logout_warning_title,
      children: <Text>{lang.new_header.logout_warning}</Text>,
      labels: {
        confirm: lang.header.menus.logout,
        cancel: lang.components.navigation_blocker.rest,
      },
      confirmProps: { color: "red" },
      onConfirm: main,
      onCancel: () => modals.closeAll(),
    });
  };

  return (
    <Menu opened={opened} onChange={setOpened} offset={0} withArrow width={330}>
      <Menu.Target>
        <Box>
          <Button
            rightSection={<IconChevronDown size={16} color="#000" />}
            variant="subtle"
            px={12}
            size="lg"
            color="#fcfbff"
            id="header-profile"
          >
            <Group gap={4} p={12} wrap="nowrap">
              <Avatar src={profile?.avatar} size={40} />
              <Stack ml={"sm"} ta={"start"} gap={0} mr={8} c={"black"}>
                <Text fw={600} truncate="end">
                  {profile?.first_name} {profile?.last_name}
                </Text>
                <Text opacity={0.5} fz={"sm"}>
                  #{profile?.id}
                </Text>
              </Stack>
            </Group>
          </Button>
        </Box>
      </Menu.Target>

      <Menu.Dropdown>
        <HeaderStats />

        <Menu.Divider />
        {links.map((group, index) => (
          <Stack key={index} gap={0}>
            {group.map((item, i) => {
              if (item.children) {
                return <HeaderTools key={i} item={item} />;
              }
              if (
                item.name === lang.new_header.billing &&
                getPermission("displayPricing")
              ) {
                return (
                  <Menu.Item
                    leftSection={item.icon}
                    component={Link}
                    to={item.url}
                    key={item.url}
                    target={
                      reseller?.name !== "Magileads" ? "_target" : undefined
                    }
                    fz={15}
                    py={12}
                  >
                    <Group ml={8}>{item.name}</Group>
                  </Menu.Item>
                );
              }
              return (
                <Menu.Item
                  leftSection={item.icon}
                  component={Link}
                  to={item.url}
                  key={item.url}
                  fz={15}
                  py={12}
                >
                  <Group ml={8}>{item.name}</Group>
                </Menu.Item>
              );
            })}
            {index < links.length - 1 && <Menu.Divider />}
          </Stack>
        ))}
        <Menu.Divider />
        <Menu.Item
          leftSection={<IconLogout />}
          onClick={handleLogout}
          color="red"
          fz={15}
          py={12}
        >
          <Group ml={5} fw={500}>
            {lang.header.menus.logout}
          </Group>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default HeaderProfile;
